// src/pages/Instituicoes/PostDetalhePage.js

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Container, Box, Button } from '@mui/material';
import PostDetalhe from '../../components/Instituicoes/PostDetalhe';
import { getPost, deletePost } from '../../services/postService';
import { useNotificacao } from '../../contexts/NotificacaoContext';
import { useAuth } from '../../hooks/useAuth';

const PostDetalhePage = () => {
  const { instituicaoId, postId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [post, setPost] = useState(null);
  const { adicionarNotificacao } = useNotificacao();

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const data = await getPost(instituicaoId, postId);
        setPost(data);
      } catch (error) {
        console.error('Erro ao buscar detalhes do post:', error);
        adicionarNotificacao('Erro ao carregar o post', 'error');
      }
    };

    fetchPost();
  }, [instituicaoId, postId, adicionarNotificacao]);

  const handleDelete = async () => {
    if (window.confirm('Tem certeza que deseja excluir este post?')) {
      try {
        await deletePost(instituicaoId, postId);
        adicionarNotificacao('Post excluído com sucesso', 'success');
        navigate(`/instituicoes/${instituicaoId}/posts`);
      } catch (error) {
        console.error('Erro ao excluir o post:', error);
        adicionarNotificacao('Erro ao excluir o post', 'error');
      }
    }
  };

  if (!post) {
    return <Typography>Carregando...</Typography>;
  }

  return (
    <Container>
      <PostDetalhe post={post} />
      {user && (user.tipo === 'admin' || (user.tipo === 'instituicao' && user.id === post.instituicaoId)) && (
        <Box mt={2}>
          <Box mb={1}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate(`/instituicoes/${instituicaoId}/posts/${postId}/editar`)}
            >
              Editar Post
            </Button>
          </Box>
          <Box>
            <Button variant="contained" color="error" onClick={handleDelete}>
              Excluir Post
            </Button>
          </Box>
        </Box>
      )}
    </Container>
  );
};

export default PostDetalhePage;